export enum RoutesKeys {
  contests = '/dashboard/contests',

  matches = '/dashboard/matches',
  matchesCreate = '/dashboard/matches/create',
  matchesEdit = '/dashboard/matches/edit/:id',

  teams = '/dashboard/teams',

  competitions = '/dashboard/competitions',
  competitionsCreate = '/dashboard/competitions/create',
  competitionsEdit = '/dashboard/competitions/edit/:id',

  pages = '/dashboard/pages',
  login = '/',
}
